import React from 'react';
import { useHistory } from 'react-router';
import ActionPanel from '../../../../../../components/action-panel-modal/action-panel';
import icon from '../../../../../../assets/img/template-confirmation-icon.svg';
import { Button } from 'react-bootstrap';

const TaskTypesCreationModal = (props) => {
    const { editMode, show, hideModal } = props;
    const history = useHistory();

    const header = `${editMode ? 'Save' : 'Create'} Task Type Confirmation`;
    const mainText = `Task Type ${editMode ? 'saved' : 'created'} successfully.`;

    const acceptButton = <Button onClick={handleAccept}>Continue Editing</Button>;

    const rejectButton = (
        <Button className="btn-outlined" onClick={handleReject}>
            Go To Task Types List
        </Button>
    );

    function handleAccept() {
        hideModal();
    }

    function handleReject() {
        history.push('/admin?tab=task-types');
    }

    const actionPanelProps = {
        show,
        onHide: handleAccept,
        header,
        icon,
        mainText,
        acceptButton,
        rejectButton,
    };

    return <ActionPanel {...actionPanelProps} />;
};

export default TaskTypesCreationModal;
